import { MaterialInput, RadioGroup } from 'app/components'
import MaterialNumber from 'app/components/material/MaterialNumber';
import { TabbedQuestion } from 'app/components/questions/tabbed'
import { AutoOwnership } from 'app/redux/Profile/model';
import * as React from 'react'
import { Col, Row } from 'react-bootstrap'

function getTitle(tab: any) {
  return tab ? tab.name : 'Car'
}

const opts = [
  { label: 'belongs to member', value: AutoOwnership.Member },
  { label: 'belongs to spouse', value: AutoOwnership.Spouse },
  { label: 'jointly owned', value: AutoOwnership.Joint }
]

const AutoQuestionsGroup = () => (
  <TabbedQuestion
    header="Auto Expenses"
    icon="fa fa-fw fa-car"
    headerDescription="In this section, you'll be entering your auto-related expenses."
    tabTitle={getTitle}
    tabTitleDefault="Car"
    pathToArray="expenses.auto[i]">
    <Row>
      <Col md={6}>
        <MaterialInput placeholder="Name of Vehicle"
          name="expenses.auto[i].name" />
      </Col>
    </Row>
    <Row>
      <Col md={6}>
        <MaterialNumber placeholder="Enter your monthly loan payment"
          formattedNumberMode
          name="expenses.auto[i].loanPayments" />
      </Col>
      <Col md={6}>
        <MaterialNumber placeholder="Enter your monthly fuel costs"
          formattedNumberMode
          name="expenses.auto[i].fuelCosts" />
      </Col>
    </Row>
    <Row>
      <Col md={6}>
        <MaterialNumber placeholder="Enter your monthly auto insurance"
          formattedNumberMode
          name="expenses.auto[i].insurance" />
      </Col>
      <Col md={6}>
        <MaterialNumber placeholder="Enter your monthly maintanence"
          formattedNumberMode
          name="expenses.auto[i].autoMaintenance" />
      </Col>
    </Row>
    <Row>
        <RadioGroup name="expenses.auto[i].ownership"
            selectedValue={AutoOwnership.Spouse} // doesn't matter.. picked up by name path
            onChange={(value) => {
              // tslint:disable-next-line:no-console
              console.log('auto ownership change: ' + value)
            }}
            parseValue={(v: string) => parseInt(v, 10)}
            noLabelBlock={true}
            options={opts} />
    </Row>
  </TabbedQuestion>
)

export {
  AutoQuestionsGroup,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Expenses/Auto/index.tsx